import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Timer';
import { injectIntl } from 'react-intl';
import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import ToCamelCase from "../../../Utils/ToCamelCase";

const Timestamp = require('react-timestamp');

const styles = () => ({
  root: {
    backgroundColor: 'rgba(201,106,124,0.15)',
    border: '1px solid rgba(201,106,124,0.3)',
    borderRadius: '4px',
    height: 'unset',
    padding: '4px',
  },
  sortRule: {
    marginRight: '5px'
  }
});

// Local Storage sortRule
const localSortRule = localStorage.getItem("sortRule") ? JSON.parse(localStorage.getItem("sortRule")).displayName : null;

const ModifiedTimeChip = (props) => {
  const { classes, timestamp, intl, sortRule } = props;
  const currentSortRule = sortRule ? sortRule : localSortRule ? localSortRule : null;
  const isSortedByTime = currentSortRule ? currentSortRule.toLowerCase().includes("modified") || currentSortRule.toLowerCase().includes("created") : false;

  const timestampComponent = (
    <Grid container>
      {
        currentSortRule &&
        (currentSortRule.toLowerCase().includes("modified") ?
          <Typography variant="caption" color="secondary" className={classes.sortRule}>{`${intl.formatMessage({id: "modified"})}:`}</Typography> :
          currentSortRule.toLowerCase().includes("created") ?
            <Typography variant="caption" color="secondary" className={classes.sortRule}>{`${intl.formatMessage({id: "created"})}:`}</Typography> : null)
      }
      <Timestamp time={timestamp} actualSeconds  />
    </Grid>
  );
  return (
    <Tooltip
      title={intl.formatMessage({ id: `sort.${isSortedByTime ? ToCamelCase(currentSortRule) : 'lastModified'}`})}
      aria-label={isSortedByTime ? currentSortRule : "Last Modified"}
    >
      <Chip
        icon={<EditIcon />}
        label={timestampComponent}
        color="secondary"
        className={classes.root}
        variant="outlined"
      />
    </Tooltip>
  );
};

ModifiedTimeChip.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  timestamp: PropTypes.string.isRequired,
  sortRule: PropTypes.string,
};

ModifiedTimeChip.defaultProps = {
  sortRule: null
};

export default withStyles(styles)(injectIntl(React.memo(ModifiedTimeChip)));
